import { type ComponentProps } from "react";

import { Input } from "@/components/ui/input";

type DeliveryCostInputProps = ComponentProps<typeof Input> & {
  currencySymbol?: string;
  invalid?: boolean;
};

/** A whole-number amount with the currency symbol inside the field, for a delivery cost. */
export const DeliveryCostInput = ({
  id,
  currencySymbol,
  invalid,
  ...props
}: DeliveryCostInputProps) => (
  <div className="relative">
    {currencySymbol && (
      <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-muted-foreground text-sm">
        {currencySymbol}
      </span>
    )}
    <Input
      {...props}
      id={id}
      type="number"
      min={0}
      step={1}
      inputMode="numeric"
      className="pl-8 border-border"
      aria-invalid={invalid}
    />
  </div>
);
